import { useMemo, useState } from "react";
import { previewDocument } from "../core/preview";
import type { TimelineState } from "../core/timeline";

/**
 * The final DOM in a fully sandboxed iframe (docs/ui-design.md §4): no
 * scripts, an opaque origin, and a CSP that blocks every load. Elements the
 * script created are outlined.
 */
export function PagePreview({ timeline }: { timeline: TimelineState }) {
  const [highlight, setHighlight] = useState(true);
  const html = timeline.html;
  const doc = useMemo(
    () => (html === null ? null : previewDocument(html, { highlight })),
    [html, highlight],
  );
  if (doc === null) {
    return (
      <p className="px-3 py-2 text-comment">
        {timeline.status === "running"
          ? "The page appears when the run finishes."
          : "Run the code to see the page it leaves behind."}
      </p>
    );
  }
  return (
    <div className="flex h-full flex-col">
      <label className="flex items-center gap-2 border-b border-border/40 px-3 py-1 text-xs text-fg-dark">
        <input
          type="checkbox"
          checked={highlight}
          onChange={(event) => setHighlight(event.target.checked)}
        />
        Highlight elements the script added
      </label>
      <iframe
        title="Page preview"
        data-testid="page-preview"
        sandbox=""
        srcDoc={doc}
        className="min-h-0 flex-1 bg-white"
      />
    </div>
  );
}
